import { ReactNode, createContext, useState } from 'react'

export type CopilotSidebarContextProps = {
    isSidebarOpen: boolean
    closeSidebar: () => void
    openSidebar: () => void
}

export const CopilotSidebarContext = createContext({} as CopilotSidebarContextProps)

const CopilotSidebarContextManager = ({ children }: { children: ReactNode }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)

    function closeSidebar() {
        setIsSidebarOpen(false)
    }

    function openSidebar() {
        setIsSidebarOpen(true)
    }

    return (
        <CopilotSidebarContext.Provider
            value={{
                isSidebarOpen,
                closeSidebar,
                openSidebar,
            }}
        >
            {children}
        </CopilotSidebarContext.Provider>
    )
}

export default CopilotSidebarContextManager
